var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrarSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6512 16.3387C25.115 15.8748 25.115 15.1215 24.6512 14.6576L19.9012 9.90762C19.4373 9.44375 18.684 9.44375 18.2201 9.90762C17.7562 10.3715 17.7562 11.1248 18.2201 11.5887L20.9439 14.3125H13.125C12.4682 14.3125 11.9375 14.8432 11.9375 15.5C11.9375 16.1568 12.4682 16.6875 13.125 16.6875H20.9439L18.2201 19.4113C17.7562 19.8752 17.7562 20.6285 18.2201 21.0924C18.684 21.5563 19.4373 21.5563 19.9012 21.0924L24.6512 16.3424V16.3387ZM11.9375 9.5625C12.5943 9.5625 13.125 9.03184 13.125 8.375C13.125 7.71816 12.5943 7.1875 11.9375 7.1875H9.5625C7.5957 7.1875 6 8.7832 6 10.75V20.25C6 22.2168 7.5957 23.8125 9.5625 23.8125H11.9375C12.5943 23.8125 13.125 23.2818 13.125 22.625C13.125 21.9682 12.5943 21.4375 11.9375 21.4375H9.5625C8.90566 21.4375 8.375 20.9068 8.375 20.25V10.75C8.375 10.0932 8.90566 9.5625 9.5625 9.5625H11.9375Z",
    fill: "#0D64A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSesion);
export default __webpack_public_path__ + "static/media/cerrar-sesion.593dd27bb2602f0ccc0b4d16f1c39a8a.svg";
export { ForwardRef as ReactComponent };